function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 76",
  d: "M9.999 21.332h-4a.667.667 0 01-.665-.668v-2.666A.667.667 0 016 17.332h4a.667.667 0 01.666.666v2.666a.667.667 0 01-.667.668zm-3.332-1.334h2.667v-1.333H6.667z",
  fill: "#17457a"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 77",
  d: "M10.666 16.666H9.333v-1.613a.667.667 0 01.485-.641 6.665 6.665 0 10-3.638 0 .665.665 0 01.487.641v1.613H5.334v-1.125a8 8 0 115.332 0z",
  fill: "#17457a"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 78",
  d: "M4.001 8.669H2.668v-.668A5.332 5.332 0 018 2.669h.668v1.333H8a4 4 0 00-4 4z",
  fill: "#17457a"
});

function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 209",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 21.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.10e9e70a.svg";
export { ForwardRef as ReactComponent };